export default {
  id: 136,
  title: 'Target #136 - Alien Eye',
  url: 'https://cssbattle.dev/play/136',
  colors: ['#998235', '#FCBE5C', '#0B2429'],
  solution:
    '<a><style>body{background:#998235}a{position:fixed;top:60;left:110;width:180;height:180;border-radius:9in;box-shadow:inset 10px 0 0 20px #fcbe5c,inset 0 0 0 40px #0b2429,inset 10px 0 0 60px #fcbe5c}</style>',
}
